import React from 'react';
import DataTable from 'components/Table/DataTable';
import { formatNumber } from '../../../../helpers';

const columns = [
    {
        name: "Service",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "Total Qty",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "Total Cost",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "Total Price",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "Total GP",
        options: {
            filter: true,
            sort: true,
        }
    }
];



class TotalsByServiceTable extends React.Component {

    render() {
        return (
            <DataTable
                title={"Totals by Service Details"}
                data={
                    this.props.data
                        .map(stat =>
                            [
                                stat.service_name,
                                formatNumber(stat.total_quantity),
                                stat.total_cost,
                                stat.total_price,
                                stat.total_gp
                            ]
                        )
                }
                columns={columns}
            />
        );
    }
}

export default TotalsByServiceTable;
